import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { Project} from '../interfaces/project';
import { User } from '../interfaces/user';
import { ProjectsService} from '../services/projects.service';
import { AuthenticationService } from '../services/authentication.service';
import { UserService } from '../services/user.service';
import { RequestService } from '../services/request.service';
import { PlansService } from '../services/plans.service';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.css']
})
export class DescriptionComponent implements OnInit {
  projectId: any;
  project: Project;
  projects: Project[];
  user: User;
  state = 'off';
  message = '';
  request: any;
  pageTitle = 'Comprar';

  constructor(
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectsService, 
    private authService: AuthenticationService,
    private userService: UserService, 
    private requestService: RequestService,
    private plansService: PlansService,
    private router: Router) {
    
    this.projectId = this.activatedRoute.snapshot.params['pid'];

    this.projectService.getProjectById(this.projectId).valueChanges().subscribe(
      (data: Project) => {
        if(data.plan.type === 'fecha') {
          const exp = new Date(data.plan.expiration);
          const today = new Date();
          if(today <= exp) {
            this.project = data;
          } else {
            alert('El producto seleccionado ya no está disponible, por favor cominicate con el administrador para mayor información.');
            this.router.navigate(['/store']);
          }
        } else {
          this.project = data;
        }
      });
  }
  ngOnInit() {
    this.authService.getStatus().subscribe(
      (status) => {
        if (status != null) {
          this.userService.getUserById(status.uid).valueChanges().subscribe(
          (data: User) => {
            this.user = data;
            this.requestService.getRequestsForEmailAndId(this.user.email, this.projectId ).valueChanges().subscribe(
              (data2) => {
                this.request = data2;
              }, (error) => {
                console.log(error);
              });
          }, (error) => {
            console.log(error);
          });
        }
      });
  }
  sendRequest(product) {
    let planId = product.plan.pid;
    
    let avatar = '';
    if(product.avatar != undefined) {
      avatar = product.avatar;
    } else {
      avatar = null;
    }
    const request = {
      timestamp: Date.now(),
      product: {
        pid: product.pid,
        name: product.name,
        avatar: avatar,
        description: product.description
      },
      sender: this.user.uid,
      email: this.user.email,
      status: 'pendiente',
      plan: planId,
      name_sender: this.user.name,
      lastname_sender: this.user.lastname
    };
    console.log(request);
    this.requestService.createRequest(request).then(
      () => {
        this.message = 'Tu requerimiento ha sido procesado con éxito, para seguir con la compra sigue los pasos que se detallan en el correo que debe haber llegado a tu buzón del correo. No olvides revisar tu el buzón de correos SPAM';
      }
    ).catch(
      (error) => {
        console.log(error);
      });
  }

}
